// Composant Header - Affiche la barre de navigation avec le logo et les liens de menu

import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import LanguageContext from "../utils/LanguageContext";

export default class HeaderNew extends Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }

  // Bascule l'ouverture/fermeture du menu mobile
  toggleMenu = () => {
    this.setState((prevState) => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));
  };

  handleLanguageChange = (language) => {
    const { setLanguage } = this.context;
    if (typeof setLanguage === "function") {
      setLanguage(language);
    }
  };

  render() {
    const { language } = this.context;
    return (
      <header className="bg-slate-50">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-6">
          <NavLink to="/" className="flex items-center">
            <img
              src="img/04-logo_etat_FR.png"
              className="h-8 mr-3"
              alt="Logo SMo"
            />
            <span className="self-center text-2xl font-semibold slatespace-nowrap dark:text-slate">
              Observatoire de la mobilité du canton de Fribourg
            </span>
          </NavLink>
          <button
            onClick={this.toggleMenu}
            type="button"
            className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-default"
            aria-expanded={this.state.isMenuOpen}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
          <div
            className={`${
              this.state.isMenuOpen ? "block" : "hidden"
            } w-full md:block md:w-auto`}
            id="navbar-default"
          >
            <div className="flex items-center justify-between">
              <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-slate">
                <li>
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive
                        ? "block py-2 pl-3 pr-4 text-blue-700 bg-transparent rounded md:bg-transparent md:text-blue-700 md:p-0"
                        : "block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0"
                    }
                    aria-current="page"
                  >
                    {language === "de" ? "Monitoring" : "Monitoring"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/indicateurs"
                    className={({ isActive }) =>
                      isActive
                        ? "block py-2 pl-3 pr-4 text-blue-700 bg-transparent rounded md:bg-transparent md:text-blue-700 md:p-0"
                        : "block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0"
                    }
                  >
                    {language === "de" ? "Indikatoren" : "Indicateurs"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/about"
                    className={({ isActive }) =>
                      isActive
                        ? "block py-2 pl-3 pr-4 text-blue-700 bg-transparent rounded md:bg-transparent md:text-blue-700 md:p-0"
                        : "block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0"
                    }
                  >
                    {language === "de" ? "Über uns" : "À propos"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/contact"
                    className={({ isActive }) =>
                      isActive
                        ? "block py-2 pl-3 pr-4 text-blue-700 bg-transparent rounded md:bg-transparent md:text-blue-700 md:p-0"
                        : "block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0"
                    }
                  >
                    {language === "de" ? "Kontakt" : "Contact"}
                  </NavLink>
                </li>
              </ul>
              <div className="ml-4 flex items-center gap-2">
                <button
                  onClick={() => this.handleLanguageChange("fr")}
                  className={`px-3 py-1 rounded ${language === "fr" ? "bg-blue-700 text-white" : "bg-gray-200 text-gray-700"}`}
                >
                  FR
                </button>
                <button
                  onClick={() => this.handleLanguageChange("de")}
                  className={`px-3 py-1 rounded ${language === "de" ? "bg-blue-700 text-white" : "bg-gray-200 text-gray-700"}`}
                >
                  DE
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
